module.exports = __webpack_public_path__ + "img/BannerProHome3.3e003d62.webp";